var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7032 7.28904C19.0959 7.67742 19.0993 8.31058 18.7109 8.70323L10.7979 16.7032C10.4404 17.0647 9.86849 17.1004 9.46882 16.7861L4.38186 12.7861C3.94772 12.4447 3.87252 11.816 4.2139 11.3819C4.55527 10.9477 5.18396 10.8725 5.6181 11.2139L10.0035 14.6623L17.289 7.29677C17.6774 6.90412 18.3106 6.90066 18.7032 7.28904Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineCheck);
export default __webpack_public_path__ + "static/media/line-check.adba9ffe983987fbb770f77745831a51.svg";
export { ForwardRef as ReactComponent };